import { useMutation } from '@tanstack/react-query';

import { reportingLeLensPath } from '~/consts/reportingLeLensApi';

import type { LensCard, LensFilterValues } from '~/types/leLens';

import { encodeRequestBody } from '~/utils/encodeRequestBody';
import { expandLensCardResponse } from '~/utils/leLensTransport';
import { requestWithTimeout } from '~/utils/requestWithTimeout';
import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

type PreviewRequest = { lensId: string; version: number; card: LensCard; filters: LensFilterValues };

export function useLensCardPreview() {
  return useMutation({
    mutationFn: async ({ lensId, ...body }: PreviewRequest) => {
      const response = await requestWithTimeout<Parameters<typeof expandLensCardResponse>[0]>(
        `${resolveReportingLeLensUrl(reportingLeLensPath(lensId))}/preview`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(encodeRequestBody(body)),
        },
        'The preview did not finish. Try again.',
        90_000,
      );
      return expandLensCardResponse(response);
    },
    retry: false,
  });
}
